import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { FormattedPrice } from "../FormattedPrice";

import styles from "./Price.module.scss";

export type PriceProps = {
  price: {
    currency: string;
    value: number;
  };
  className?: string;
  frequency?: string;
  frequencyClassName?: string;
  frequencySeparator?: string;
};

export const Price: FC<PriceProps> = ({
  price,
  frequency,
  frequencySeparator = "/",
  frequencyClassName,
  className,
}) => {
  const { __ } = useTranslations();
  const { currency, value } = price;

  return (
    <div className={classNames(styles.price, className)}>
      {value === -1 ? __("libs.ui.price.na") : <FormattedPrice value={value} currency={currency} />}
      {frequency ? (
        <span className={frequencyClassName}>
          {frequencySeparator}
          {frequency}
        </span>
      ) : null}
    </div>
  );
};
